import { createComponent } from '@carvana/merch-components';

export const PromoCard = createComponent('div', {
  className:
    'flex w-full min-w-[327px] max-w-[560px] flex-1 flex-col overflow-hidden rounded-[8px] border border-grey-2 bg-white'
});

export const Image = createComponent('img', {
  className: 'h-[140px] w-full rounded-t-[8px] object-cover m:h-[208px]'
});

export const InnerWrapper = createComponent('div', {
  className:
    'mx-auto flex max-w-[263px] grow flex-col items-center py-24 m:max-w-fit m:px-8'
});

export const Title = createComponent('div', {
  className: 'text-blue-7 l:tl-header-xl'
});

export const Copy = createComponent('div', {
  className:
    'mb-12 mt-4 w-full grow text-center text-grey-5 tl-body-s m:mb-16 m:mt-8 m:w-fit m:tl-body-m'
});
